import { FileItem } from "../types";


// Constants
export const FILE_STORAGE_KEY = 'knowledgeBaseUploadedFiles';

// Helper functions for localStorage
export const saveFilesToStorage = (files: FileItem[]) => {
  try {
    localStorage.setItem(FILE_STORAGE_KEY, JSON.stringify(files));
  } catch (error) {
    console.error('Error saving files to localStorage:', error);
  }
};

export const getFilesFromStorage = () => {
  try {
    const storedFiles = localStorage.getItem(FILE_STORAGE_KEY);
    return storedFiles ? JSON.parse(storedFiles) : [];
  } catch (error) {
    console.error('Error getting files from localStorage:', error);
    return [];
  }
};

// Check if file ID already exists
export const fileIdExists = (fileId: string) => {
  const files = getFilesFromStorage();
  return files.some((file: FileItem) => file.id === fileId);
};


export const addFileToKnowledgeBase = (fileData: FileItem) => {
    const files = getFilesFromStorage();
    
    // Check if file with same ID already exists
    const existingIndex = files.findIndex((file: FileItem) => file.id === fileData.id);
    
    if (existingIndex >= 0) {
      // Replace the entire object at the found index
      files[existingIndex] = fileData;
    } else {
      // Add new file
      files.push(fileData);
    }
    
    saveFilesToStorage(files);
    return files;
  };

// Remove a file from knowledge base array by ID
export const removeFileFromKnowledgeBase = (fileId: string) => {
  const files = getFilesFromStorage();
  const updatedFiles = files.filter((file: FileItem) => file.id !== fileId);
  
  // Check if any file was removed
  if (updatedFiles.length === files.length) {
    console.warn(`File with ID ${fileId} not found`);
  } else {
    saveFilesToStorage(updatedFiles);
  }
  
  return updatedFiles;
};